import {
	expand,
	collapse
} from '@legacynotes/frontend/src/components/expandable/expandable-transition';

const animate = {
	methods: {
		enter(element, done) {
			expand(element).then(done);
		},
		leave(element, done) {
			collapse(element).then(done);
		}
	}
};

export default animate;
